import { FontColorPermission } from './font-color-permission';

export class FontBackgroundColorPermission extends FontColorPermission
{
}
